<template>
  <div
    v-if="!loading"
    class="exam-card_wrap"
  >
    <div class="exam-card_main">
      <div class="exam-card_tag" v-if="showGradeTime">已参加</div>
      <div :class="['exam-card', { 'exam-card_ai': detail.invigilateStatus }]">
        <div class="exam-card_title">
          <img :src="detail.invigilateStatus ? IC_AI : IC_EDIT " class="exam-card_title-ic" />
          <span class="exam-card_title-text">{{ detail.roundName }}</span>
        </div>
        <div class="exam-card_bottom">
          <div class="exam-card_content">
            <div v-if="showGradeTime" class="exam-card_time">成绩公布时间：{{ detail.releaseResultTime | formatTime }}</div>
            <div v-else class="exam-card_time">{{ formalTimeRange[0] | formatTime2 }}—{{ formalTimeRange[1] | formatTime2 }}</div>
            <div class="exam-card_info">
              <span class="question-count">共{{ detail.questionCount || '--' }}题</span>限时（{{ detail.rule?.costTime || '--' }}分钟）
            </div>
          </div>
          <div class="exam-card_action">
            <!--ai检测-->
            <button
                v-if="detail.invigilateStatus"
                class="exam-btn exam-btn_ai"
                @click="onDeviceTest"
            >
              AI监考检测
            </button>
            <!-- 开始考试按钮 -->
            <template v-if="cardStatus === 'RUNNING'">
              <button
                  v-if="!userExamInfo"
                  class="exam-btn exam-btn_start"
                  @click="handleCardClick"
              >
                开始考试
              </button>
              <button
                  v-else-if="userExamInfo?.status === 0"
                  class="exam-btn exam-btn_start"
                  @click="handleCardClick"
              > 继续考试</button>
              <button
                  v-else-if="userExamInfo?.status === 1"
                  class="exam-btn exam-btn_start"
                  @click="handleCardClick"
              >考试已完成</button>
            </template>
            <!-- 考试未开始按钮 -->
            <template  v-else-if="cardStatus === 'NOT_START'">
              <button
                  v-if="canEnterInAdvance"
                  class="exam-btn exam-btn_start"
                  @click="handleCardClick"
              >
                准备考试
              </button>
              <button
                  v-else
                  class="exam-btn exam-btn_notstart"
                  @click="handleCardClick"
              >
                考试未开始
              </button>
            </template>
            <!-- 考试已结束按钮 -->
            <template v-else>
              <!-- 查看成绩按钮 -->
              <button
                  v-if="canCheckGrade"
                  class="exam-btn exam-btn_grade"
                  @click.stop="handleCardClick"
              >
                查看我的成绩
              </button>
              <button
                  v-else
                  class="exam-btn exam-btn_over"
                  @click="handleCardClick"
              >
                考试已结束
              </button>
            </template>
          </div>
        </div>
<!--        <div class="ai-check-tag" v-if="!showGradeTime && detail.invigilateStatus"><span class="ic-ai"></span>AI监考</div>-->
      </div>
    </div>
<!--    <div class="exam-card_footer" v-if="detail.invigilateStatus">-->
<!--      <div class="footer-left"><span class="ic-ai"></span>本场考试开启在线AI监考（考前请进行设备检测）</div>-->
<!--      <div class="button black size-small" @click="onDeviceTest">设备检测</div>-->
<!--    </div>-->
  </div>
</template>

<script>
import { getSystemTime } from '@/api/api';
import dayjs from 'dayjs';
import { checkStartExam } from '@/api/qzStudent';
import IC_AI from '@/common/images/ic_ai.png';
import IC_EDIT from '@/common/images/student/ic_edit.png';

export default {
  name: 'ExamPaperCard',
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
  },
  filters: {
    formatTime(time) {
      return time ? dayjs(time).format('YYYY年M月D日 HH:mm:ss') : '';
    },
    formatTime2(time) {
      return time ? dayjs(time).format('HH:mm:ss') : '';
    }

  },
  computed: {
    userExamInfo() {
      return this.detail.userCourseExamRelationInstance || null;
    },
    formalTimeRange() {
      const { startTime, rule } = this.detail;
      const costTime = rule?.costTime || 0;
      return [startTime, startTime + costTime * 60 * 1000];
    },
    showGradeTime() {
      return this.cardStatus === 'OVER' && !!this.userExamInfo; // 已结束，且已参加过考试
    }
  },
  data() {
    return {
      IC_AI,
      IC_EDIT,
      cardStatus: '', // 考试状态 RUNNING: 进行中，NOT_START: 未开始，OVER：已结束
      canCheckGrade: false,
      loading: true,
      timer: null,
      canEnterInAdvance: false, // 提前进入考试，打开监考的考试能够提前30分钟进入
    };
  },
  created() {
    this.checkStatus().then(() => {
      this.loading = false;
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    onDeviceTest() {
      this.$emit('device-test', `examId=${this.detail.courseExamId}&roundId=${this.detail.id}`);
    },
    async handleCardClick() {
      await this.checkStatus();
      if (this.cardStatus === 'NOT_START') { // 考试未开始
        if (this.canEnterInAdvance) { // 监考提前进入
          this.checkStartExam();
          return;
        }
        this.$message({
          message: `考试时间未开始～请在「${dayjs(this.detail.startTime).format('YYYY年M月D日 HH:mm:ss')}」后开始`,
          type: 'warning',
          customClass: 'el-message-red',
        });
        return;
      } else if (this.cardStatus === 'RUNNING') { // 考试进行中
        this.checkStartExam();
      } else { // 考试已结束
        if (!this.userExamInfo) {
          this.$message({
            message: '考试已经结束，下次再来吧～',
            type: 'warning',
            customClass: 'el-message-red',
          });
          return;
        } else if (this.canCheckGrade) {
          this.$emit('show-grade', this.userExamInfo);
        } else {
          this.$message({
            message: '成绩暂未公布，请耐心等待',
            customClass: 'el-message-red',
            type: 'warning',
          })
        }
      }
    },

    async checkStatus() {
      const { startTime, releaseResultTime, rule, userCourseExamRelationInstance: userExamInfo, invigilateStatus } = this.detail;
      const costTime = rule?.costTime || 0;
      const now = await getSystemTime(true);
      this.cardStatus = now < startTime
        ? 'NOT_START'
        : (now < startTime + costTime * 60 * 1000
          ? 'RUNNING'
          : 'OVER'
        );
      this.canEnterInAdvance = now >= (startTime - 30 * 60 * 1000) && invigilateStatus; // 提前进入考试，打开监考的考试能够提前30分钟进入
      this.canCheckGrade = now >= releaseResultTime && userExamInfo?.markStatus === 2; // 0未批改  1批改中 2已核对
      if (this.cardStatus === 'NOT_START') {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        const restTime = invigilateStatus && !this.canEnterInAdvance
          ? startTime - now - 30 * 60 * 1000
          : startTime - now;
        this.timer = setTimeout(() => {
          this.checkStatus();
        }, Math.max(0, restTime));
      }
    },

    checkStartExam() {
      if (!this.userExamInfo) { // 首次进入考试
        checkStartExam({courseExamId: this.detail.courseExamId, roundId: this.detail.id}).then((res) => {
          if (res.code === 200) {
            if (res.body?.checkResult) {
              this.$emit('start-exam', this.detail);
              return;
            }
            throw new Error(res.body.reason || '无法参加考试');
          }
        }).catch((err) => {
          this.$message({
            message: err?.message || '无法参加考试',
            type: 'warning',
            customClass: 'el-message-red',
          })
        })
      } else if (this.userExamInfo.status === 0){ // 继续考试
        this.$emit('continue-exam', this.detail);
      } else {
        this.$message({
          message: '您的考试机会已经消耗，无法参加本次考试',
          type: 'warning',
          customClass: 'el-message-red',
        });
        return;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.exam-card_wrap {
  width: 100%;
  max-width: 504px;
  padding: 0;
  position: relative;
  user-select: none;
  .ai-check-tag{
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
    background: linear-gradient(90deg, rgba(56, 126, 255, 0.15) 0%, rgba(101, 93, 255, 0.15) 100%);
    border-top-right-radius: 12px;
    border-bottom-left-radius: 12px;
    width: 90px;
    height: 26px;
    color: #1D2129;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    .ic-ai {
      margin-right: 4px;
      width: 20px;
      height: 20px;
      background: url('@/common/images/ic_ai.png') center / contain no-repeat;
    }
  }
  .exam-card_tag {
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
    background-color: #E60012;
    border-top-right-radius: 12px;
    border-bottom-left-radius: 12px;
    width: 74px;
    height: 25px;
    line-height: 25px;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
  }
  &.exam-card_disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
  .exam-card_footer {
    position: relative;
   margin-top: -12px;
    box-sizing: border-box;
    border-radius: 0 0 12px 12px;
    padding: 6px 20px 0 20px;
    height: 70px;
    background: linear-gradient(90deg, rgba(56, 126, 255, 0.15) 0%, rgba(101, 93, 255, 0.15) 100%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #1D2129;
    font-size: 13px;
    font-weight: 500;
    .footer-left {
      display: flex;
      align-items: center;
    }
    .ic-ai {
      margin-right: 4px;
      width: 20px;
      height: 20px;
      background: url('@/common/images/ic_ai.png') center / contain no-repeat;
    }
    .button {
      width: 80px;
    }
  }
}
.exam-card {
  border-radius: 12px;
  background: #F5F6F9;
  cursor: pointer;
  //display: flex;
  //align-items: flex-end;
  padding: 32px 24px 28px;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  &_ai{
    background: linear-gradient(90deg, #EDF3FF 0%, #EAEBFF 100%);
  }
}
.exam-card_bottom{
  display: flex;
  align-items: flex-end;
}
.exam-card_content {
  flex: 1;
  margin-right: 10px;
}
.exam-card_title {
  width:100%;
  font-size: 18px;
  font-weight: 600;
  color: #1D2129;
  margin-bottom: 8px;
  height: 50px;
  display: flex;
  &-ic {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    flex: none;
  }
  &-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.exam-card_info {
  font-size: 12px;
  line-height: 20px;
  color: #86909C;
  .question-count {
    margin-right: 8px;
  }
}
.exam-card_time {
  font-size: 14px;
  color: #86909C;
  margin-bottom: 2px;
}
.exam-card_action {
  display: flex;
  align-items: center;
  gap: 10px;
}
.exam-btn {
  border: none;
  outline: none;
  border-radius: 90px;
  font-size: 13px;
  font-weight: 600;
  height: 34px;
  width: 102px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &.exam-btn_ai{
    border: 1px solid #000000;
    color: #1D2129;
  }
  &.exam-btn_start {
    background: #e92d23;
    color: #fff;
  }
  &.exam-btn_notstart {
    background: #F1ACB1;
    color: #fff;
  }
  &.exam-btn_over {
    background: #E5E6EB;
    color: #86909C;
    cursor: not-allowed;
  }
  &.exam-btn_grade {
    background: #000000;
    color: #fff;
  }
}
</style>